import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

type Props = {
  readonly icon: React.ReactElement;
  readonly title: string | null | undefined;
  readonly subtitle: string | null;
};
export default function NetWorthItemDescriptionRow({ icon, title, subtitle }: Props) {
  const isSmallScreen = useIsSmallScreen();
  return (
    <div className="flex items-center">
      <div className={cn('flex flex-row items-end', isSmallScreen ? 'pr-2' : 'pr-4')}>{icon}</div>
      <div className="flex flex-col gap-0">
        <Text variant={isSmallScreen ? 'body-sm' : undefined} color={isSmallScreen ? undefined : 'dark'}>
          {title}
        </Text>
        <Text color="secondary" variant={isSmallScreen ? 'caption' : 'body-sm'}>
          {subtitle}
        </Text>
      </div>
    </div>
  );
}
